export const protocolState = {
  selProtocol: '',
  selPrtTab: '/protocoldetail'
};

export const protocolDetailState = {
  prtInfo: {},
  prtStatusChangeHist: [],
  cohortData:[],
  cohortHistory:[],
  strataHistory:[]
};

export const versionsState = {
  localVersions: {},
  pioVersions: {}
};

export const studyAgentsState = {
  ctepStudyAgents: {},
  nonCTEP: {}
};

export const cirbState = {
  eventDocs: {}
};

export const integrationsState = {
  integrationInfo: {},
  startInfo: {}
};

export const openState = {
  openData: {},
  regStepindex: 0,
  relations: [],
  embedded: []
};

export const participationState = {
  countries: {},
  participationInfo: {},
  studyChampions: {}
};

export const psrsState = {
  psrInfo: {},
  psrSplReqAffi: {},
  psrIndex: 0,
  psrId: null,
  affiliationsHistory: {},
  selectedPsr: {}
};

export const fundingState = {
  fundings: {},
  fundingIndex: 0,
  fundingId: null
};
